import axios from "axios";
import React, {useEffect, useState} from 'react';
import {Link, useParams} from "react-router-dom";
import { useDispatch } from 'react-redux';
import { updateBreadcrumb } from './store/breadcrumbSlice';

const ContactSolution = (props) => {
  const dispatch = useDispatch()

  const docid = useParams()["docid"];
  const [doc, setDoc] = useState(null);
  const relativeUrl = props.relativeUrl
  const apiLink = props.layout ?
    window.location.protocol+"//"+window.location.host+"/osp/"+nortonAnalytics.site_language+"/"+nortonAnalytics.site_country+"/contact/kb/"+docid+"?layout="+props.layout :
    window.location.protocol+"//"+window.location.host+"/osp/"+nortonAnalytics.site_language+"/"+nortonAnalytics.site_country+"/contact/kb/"+docid;

  useEffect(() => {
    dispatch(updateBreadcrumb("review"));

    const fetchData = async () => {
      const res = await axios.get(`${apiLink}`, { headers: { Accept: "application/json" } });
      setDoc(res.data)
    }
    fetchData();

    // Analytics: set eVar13 to the docid when KB doc loads
    s.eVar13 = docid;
    s.tl();

  }, []);

  useEffect(() => {
    if ($(".twistee").length > 0) {
      if ($(".twist-title-container").length === 0) {
        //Move the Twistee titles into a container and add the Chevron
          $(".twistee").each(function(){
              $(this).find("h3").first().wrap("<div class='twist-title-container'></div>");
              $(this).find(".twist-title-container").append("<div class=\"chevron\">&rsaquo;</div>");
          });

        // Add Click Event for twistees
        $(".twistee").click(function(){
          $(this).find(".twistee_content").slideToggle();
          $(this).find(".chevron").toggleClass("open");
        });
      }
    }

    // Add classes in KB docs to differentiate between small inline icon type images and large screenshots
    if ($("#kbwrapper img").length > 0) {
      if (($(".img-lg").length === 0) && ($(".img-sm").length === 0)) {
        var kbwrapperImages = document.querySelectorAll("#kbwrapper img");
        for (var i = 0; i < kbwrapperImages.length; i++) {
            var img = new Image();
            img.onload = function() {
                if (this.height > 50) {
                    $("img[src$='"+this.src+"']").addClass("img-lg");
                } else {
                    $("img[src$='"+this.src+"']").addClass("img-sm");
                }
            }
            img.src = kbwrapperImages[i].src
        }
      }
    }   
  
  });

  return (
    <div id="contact-solutions" className="container mt-5 text-left">
      { (doc === null) ? <div id="contact-spinner" className="text-center mb-5"><img src="https://support.norton.com/sp/static/external/assets/images/vulcan/symassets/northstar-v2-loading-spinner.gif"/></div> :
        <>
          <div id="kbstart" dangerouslySetInnerHTML={{ __html: doc["kb_body"] }}/>
          <div id="docinfo">
            <strong>{props.contentStrings['review-kb-docid']}&nbsp;</strong><span id="docIDval">{doc["docid_val"]}</span><br/>
            <strong>{props.contentStrings['review-kb-os']}&nbsp;</strong><span id="docOSval">{doc["doc_os_val"]}</span><br/>
            <strong>{props.contentStrings['review-kb-modified']}&nbsp;</strong><span id="docLastModVal">{doc["doc_last_mod_val"]}</span>
          </div>
        </>
      }
      <div id="contact-solutions-return"><Link to={relativeUrl+"/"}>{props.contentStrings['review-kb-back-btn']}</Link></div>
    </div>
  )
}
export default ContactSolution